import { Component, Host, h, Prop, Element } from '@stencil/core';
import Splide from '@splidejs/splide';

@Component({
    tag: 'sew-ws-news-feed',
    styleUrl: 'sew-ws-news-feed.scss',
    shadow: false,
})
export class SewWsNewsFeed {
    @Element() host: HTMLSewWsNewsFeedElement;

    @Prop() headline: string;
    @Prop({ reflect: true }) noMargin = false;

    private newsFeedSplide: Splide;

    private checkImageHeight = (): void => {
        this.host.style.setProperty(
            '--image-height',
            this.host.querySelector('*[slot="picture"]').clientHeight + 'px'
        );
    };

    private resizeObserver: ResizeObserver = new ResizeObserver(this.checkImageHeight);

    componentDidLoad(): void {
        const showArrows = this.host.querySelectorAll('sew-ws-news-feed-item').length > 3;

        this.newsFeedSplide = new Splide(this.host.querySelector('.news-feed-slider') as HTMLElement, {
            classes: {
                pagination: 'splide__pagination news-pagination',
                page: 'splide__pagination__page news-page',
            },
            rewind: true,
            mediaQuery: 'min',
            gap: 0,
            direction: 'ltr',
            perPage: 1,
            pagination: true,
            arrows: false,
            width: '100%',
            rewindByDrag: true,
            breakpoints: {
                768: {
                    gap: 32,
                    perPage: 3,
                    arrows: showArrows,
                    pagination: false,
                },
                1024: {
                    gap: 48,
                    perPage: 3,
                    arrows: showArrows,
                    pagination: false,
                },
            },
        });

        this.newsFeedSplide.mount();
        this.resizeObserver.observe(this.host.querySelector('*[slot="picture"]'));
    }

    render() {
        return (
            <Host>
                <h2 innerHTML={this.headline}></h2>
                <slot name="link" />
                <div class="splide news-feed-slider">
                    <div class="splide__track">
                        <div class="splide__list">
                            <slot />
                        </div>
                    </div>
                </div>
            </Host>
        );
    }
}
